import React, { forwardRef } from 'react';
import './button.css';

const Button = forwardRef(
    ({ children, onClick, disabled = false, type = 'button', className = '', icon, ...props }, ref) => {
        return (
            <button
                ref={ref}
                type={type}
                onClick={onClick}
                disabled={disabled}
                className={`btn ${className}`}
                {...props}
            >
                {icon && <span className='btn-icon'>{icon}</span>}
                {children}
            </button>
        );
    }
);

export default Button;
